var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNewChange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.55556 14.2222C3.41467 14.2222 4.11111 13.5258 4.11111 12.6667C4.11111 11.8076 3.41467 11.1111 2.55556 11.1111C1.69645 11.1111 1 11.8076 1 12.6667C1 13.5258 1.69645 14.2222 2.55556 14.2222Z",
    stroke: "#000",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4447 4.88891C14.3038 4.88891 15.0003 4.19247 15.0003 3.33336C15.0003 2.47425 14.3038 1.7778 13.4447 1.7778C12.5856 1.7778 11.8892 2.47425 11.8892 3.33336C11.8892 4.19247 12.5856 4.88891 13.4447 4.88891Z",
    stroke: "#000",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4444 4.88887V8.77776C13.4444 9.80916 13.0347 10.7983 12.3054 11.5276C11.5761 12.2569 10.5869 12.6666 9.5555 12.6666H7.22217L9.5555 15",
    stroke: "#000",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55566 11.1111V7.22222C2.55566 6.19082 2.96539 5.20167 3.69469 4.47236C4.424 3.74305 5.41316 3.33333 6.44455 3.33333H8.77789M8.77789 3.33333L6.44455 1M8.77789 3.33333L6.44455 5.66667",
    stroke: "#000",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNewChange);
export default __webpack_public_path__ + "static/media/icon--new-change.440b703807ed04af5745d983aa3b893c.svg";
export { ForwardRef as ReactComponent };